import { ReactElement } from 'react';
import MuiButton from '@mui/material/Button';
import MuiLoadingButton from '@mui/lab/LoadingButton';

type ButtonProps = {
  label: string;
  disabled?: boolean;
  withLoader?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
  variant?: 'text' | 'outlined' | 'contained';
  fullWidth?: boolean;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  sx?: object;
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
};

const Button = ({
  variant = 'contained',
  label,
  color,
  disabled = false,
  type,
  onClick,
  onMouseEnter,
  onMouseLeave,
  fullWidth,
  className,
  startIcon,
  endIcon,
  withLoader = false,
  loading = false,
  size,
  sx,
}: ButtonProps) => {
  if (withLoader) {
    return (
      <MuiLoadingButton
        sx={sx}
        type={type}
        disabled={disabled}
        loading={loading}
        variant={variant}
        color={color}
        size={size}
        onClick={onClick}
        fullWidth={fullWidth}
        className={className}
        startIcon={startIcon}
        endIcon={endIcon}
      >
        {label}
      </MuiLoadingButton>
    );
  }
  return (
    <MuiButton
      sx={sx}
      type={type}
      disabled={disabled}
      variant={variant}
      color={color}
      size={size}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      fullWidth={fullWidth}
      className={className}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {label}
    </MuiButton>
  );
};

export default Button;
